import React from "react";
import { Link } from "react-router-dom";

function Doc({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="max-w-2xl mx-auto px-6 py-14 text-[15px] leading-7 space-y-4" data-testid="legal-page">
      <Link to="/" className="text-sm underline text-muted-foreground">← Instant Quote Wizard</Link>
      <h1 className="text-3xl font-bold">{title}</h1>
      <p className="text-xs uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 rounded p-3">Draft template — to be reviewed and completed by [Company legal name] and counsel before launch.</p>
      {children}
    </div>
  );
}

export function Terms() {
  return (
    <Doc title="Terms of Service">
      <p>Instant Quote Wizard (“the Service”) is operated by [Company legal name]. The Service lets home-service businesses (“Contractors”) show homeowners a preliminary, self-measured estimate on a satellite map.</p>
      <h2 className="text-lg font-bold">Estimates are not offers</h2>
      <p>All prices shown are preliminary estimates based on the homeowner’s own drawing and the Contractor’s pricing rules. They are subject to verification of property size and conditions and are not a binding service agreement. Taxes, if applicable, are not included. Measurements are approximate plan-view areas only.</p>
      <h2 className="text-lg font-bold">Contractor responsibilities</h2>
      <p>Contractors set their own prices, are responsible for the services they provide, and must only contact homeowners about the inquiry they submitted unless separate consent is obtained.</p>
      <h2 className="text-lg font-bold">Subscriptions</h2>
      <p>The pilot plan is billed monthly through Stripe. You can cancel at any time from the billing portal; access continues until the end of the paid period.</p>
      <h2 className="text-lg font-bold">Maps</h2>
      <p>Map imagery is provided by Google. Use of map features is subject to the <a className="underline" href="https://maps.google.com/help/terms_maps/" target="_blank" rel="noreferrer">Google Maps/Google Earth Additional Terms of Service</a>.</p>
    </Doc>
  );
}

export function Privacy() {
  return (
    <Doc title="Privacy Policy">
      <p>When a homeowner requests a quote, we collect the name, email and/or phone, the confirmed service address, the shapes drawn on the map, and consent records. This information is shared only with the Contractor whose form was used, so they can respond to the inquiry.</p>
      <p>We do not sell personal information. We do not send marketing messages on a Contractor’s behalf. Contractors may export or delete their leads at any time.</p>
      <p>Address search and maps are provided by Google; Google’s use of data is described in the <a className="underline" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google Privacy Policy</a>.</p>
      <p>Requests about your data: contact the Contractor directly, or [privacy contact email].</p>
    </Doc>
  );
}
